import { api } from ".";

export default class NegotiationMassive {
  static async importContracts(contractType: string, id: number, formData: FormData, config: any): Promise<{}> {
    const res = await api.post(`/contracts/batch/${contractType}/${id}`, formData, config);
    return res.data;
  }

  static async exportContracts(contractType: string, id: number): Promise<any> {
    return await api.get(`/contracts/batch/${contractType}/${id}`, { responseType: 'blob' });
  }
}
